<!-- page-banner -->
@if (pageBannerContent) {
  <div class="container-fluid">
    @if (pageBannerContent['img']) {
      <img src="{{pageBannerContent['img']}}" no-image/>
    }
    <h1 class="main-title" translate>{{pageBannerContent['title']}}</h1>
    <p class="sub-title">{{pageBannerContent['description']}}</p>
  </div>
}
<!-- end page-banner -->
